import StandPhotoForm from "./stand-photo-form";


export default StandPhotoForm;